<template>
    <b-card no-body>
        <v-table ref="table" name="po-filo-codes" :items-provider="provider" :fields="fields" :buttons="buttons" pagination="server" search :add-callback="createNew"> </v-table>

        <b-modal v-model="modal.show" :title="modal.title" ok-title="Kaydet" ok-only @ok.prevent="save" :busy="modal.busy">
            <form ref="form">
                <div class="mb-1">
                    <label class="form-label">Filo Kodu</label>
                    <input type="text" class="form-control" v-model="form.Code" placeholder="Örn: 1001" required />
                </div>
                <div class="mb-1">
                    <label class="form-label">Açıklama</label>
                    <input type="text" class="form-control" v-model="form.Description" placeholder="Örn: Ege Bölge Araçları" />
                </div>
                <div class="mb-1">
                    <b-form-checkbox v-model="form.IsActive" switch> Aktif </b-form-checkbox>
                </div>
            </form>
        </b-modal>
    </b-card>
</template>

<script>
import { BCard, BModal, BFormCheckbox } from "bootstrap-vue";
import FuelOperationApi from "@/api/fuel-operations";

export default {
    components: {
        BCard,
        BModal,
        BFormCheckbox,
    },
    data() {
        return {
            fields: [
                { name: "Filo Kodu", key: "Code", sortable: true, sortKey: "Code" },
                { name: "Açıklama", key: "Description", sortable: true, sortKey: "Description" },
                { name: "Durum", key: "IsActive", sortable: true, sortKey: "IsActive" },
            ],
            buttons: [
                {
                    text: "Düzenle",
                    icon: "EditIcon",
                    variant: "primary",
                    action: (item) => this.edit(item),
                },
                {
                    text: "Sil",
                    icon: "TrashIcon",
                    variant: "danger",
                    action: (item) => this.remove(item),
                },
            ],
            modal: {
                show: false,
                title: "Yeni Filo Kodu",
                busy: false,
                isEdit: false,
            },
            form: {
                Id: null,
                Code: "",
                Description: "",
                IsActive: true,
            },
        };
    },
    methods: {
        provider(data) {
            return FuelOperationApi.PetrolOfisi.FiloCode.Table(data);
        },
        createNew() {
            this.resetForm();
            this.modal.isEdit = false;
            this.modal.title = "Yeni Filo Kodu";
            this.modal.show = true;
        },
        edit(item) {
            this.form = { ...item };
            this.modal.isEdit = true;
            this.modal.title = "Filo Kodu Düzenle";
            this.modal.show = true;
        },
        save() {
            this.modal.busy = true;
            const request = this.modal.isEdit ? FuelOperationApi.PetrolOfisi.FiloCode.Update(this.form) : FuelOperationApi.PetrolOfisi.FiloCode.Create(this.form);

            request
                .then((res) => {
                    if (res.data.Success) {
                        this.$refs.table.refresh();
                        this.modal.show = false;
                        this.$toast.success(res.data.Message);
                    } else {
                        this.$toast.error(res.data.Message);
                    }
                })
                .catch((err) => {
                    this.$toast.error("İşlem sırasında bir hata oluştu.");
                    console.error(err);
                })
                .finally(() => {
                    this.modal.busy = false;
                });
        },
        remove(item) {
            this.$confirm("Silmek istediğinize emin misiniz?", `Bu işlem ${item.Code} kodlu filo tanımını silecektir.`).then((res) => {
                if (res) {
                    this.$refs.table.rowLoading(true);
                    FuelOperationApi.PetrolOfisi.FiloCode.Delete(item.Id)
                        .then((res) => {
                            this.$result(res);
                            if (res.data.Success) {
                                this.$refs.table.refresh();
                            }
                        })
                        .catch((err) => {
                            this.$result(null, err);
                        })
                        .finally(() => {
                            this.$refs.table.rowLoading(false);
                        });
                }
            });
        },
        resetForm() {
            this.form = {
                Id: null,
                Code: "",
                Description: "",
                IsActive: true,
            };
        },
    },
};
</script>
